import { Directive, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NavigationService } from '../navigation/services/navigation.service';
import { HttpRequestService } from '../services/http-request/http-request.service';

const dureeInactiviteInMs = 180 * 60 * 1000; // 180mn , 3h

@Directive({
  selector: '[appAutoLogoutOnInactivity]',
})
export class AutoLogoutOnInactivityDirective implements OnDestroy {
  @Input('appAutoLogoutOnInactivity') isLogguedIn: boolean;
  subscriptionTickHttpRequest: Subscription;

  constructor(
    private httpRequestService: HttpRequestService,
    private router: Router,
    private navigationService: NavigationService,
  ) {
    this.subscriptionTickHttpRequest = this.httpRequestService.httpRequestTickStart
      .pipe(debounceTime(dureeInactiviteInMs))
      .subscribe(() => this.redirectToLoginIsLogguedIn());
  }

  ngOnDestroy(): void {
    if (this.subscriptionTickHttpRequest) {
      this.subscriptionTickHttpRequest.unsubscribe();
    }
  }

  redirectToLoginIsLogguedIn(): void {
    if (this.isLogguedIn) {
      this.navigationService.root.login.navigate(this.router.url, true);
    }
  }
}
